module.exports = __webpack_public_path__ + "media/Q4.d511afdf.mp4";